import { useEffect, useRef, useState } from "react";
import { Alert, Button, Snackbar } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useClientDispatch, useClientSelector } from "../../Redux/clientHooks.ts";
import {
	socialInvitationsSelector,
	socialOverviewSelector,
	setFriendsOpen,
	friendsOpenSelector,
} from "../../Redux/social.slice.ts";
import { FriendsDialog } from "./FriendsDialog.tsx";
import { FriendshipStatus } from "../../Domain/Social/SocialTypes.ts";
import { useUiI18n } from "../../I18n/index.ts";
export function SocialNotifications() {
	const invitations = useClientSelector(socialInvitationsSelector),
		overview = useClientSelector(socialOverviewSelector),
		{ pathname } = useLocation(),
		navigate = useNavigate(),
		{ t } = useUiI18n();
	const inWorld = pathname.startsWith("/worlds/") || pathname.startsWith("/world-sessions/");
	const inGame = inWorld || pathname.startsWith("/matches/");
	const dispatch = useClientDispatch();
	const friendsOpen = useClientSelector(friendsOpenSelector);
	const [open, setOpen] = useState(false),
		seen = useRef(new Set<string>()),
		account = useRef<string | null>(null);
	useEffect(() => {
		if (!overview) return;
		if (account.current !== overview.self.id) {
			account.current = overview.self.id;
			seen.current.clear();
		}
		const ids = [
			...invitations
				.filter((invite) => !invite.read)
				.map((invite) => `invite:${invite.id}:${invite.status}`),
			...overview.relationships
				.filter((relation) => relation.unread && relation.status === FriendshipStatus.Pending)
				.map((relation) => `friend:${relation.profile.id}:${relation.requestCreatedAt}`),
		];
		if (
			ids.some((id) => !seen.current.has(id)) &&
			pathname !== "/friends" &&
			!pathname.startsWith("/invitations/")
		)
			setOpen(true);
		for (const id of ids) seen.current.add(id);
	}, [invitations, overview, pathname]);
	return (
		<>
			<FriendsDialog />
			<Snackbar
				anchorOrigin={{ vertical: inWorld ? "top" : "bottom", horizontal: "left" }}
				sx={
					inGame
						? {
								zIndex: (theme) => theme.zIndex.modal - 1,
								...(inWorld
									? {
											top: {
												xs: "calc(132px + env(safe-area-inset-top))",
												sm: "calc(80px + env(safe-area-inset-top))",
											},
										}
									: { bottom: { xs: 80, sm: 24 } }),
							}
						: undefined
				}
				open={
					!friendsOpen &&
					open &&
					!!overview &&
					pathname !== "/friends" &&
					!pathname.startsWith("/invitations/")
				}
				autoHideDuration={8000}
				onClose={() => setOpen(false)}
			>
				<Alert
					severity="info"
					onClose={() => setOpen(false)}
					action={
						<Button
							color="inherit"
							onClick={() => {
								setOpen(false);
								if (inGame) dispatch(setFriendsOpen(true));
								else void navigate("/friends");
							}}
						>
							{t("social.viewRequests")}
						</Button>
					}
				>
					{t("social.newNotifications")}
				</Alert>
			</Snackbar>
		</>
	);
}
